import api from '@/api';

const { $pricing } = api;

export const { $repayments, $billingProps } = $pricing;
